export default __webpack_public_path__ + "images/885370414ea07da8d07f0364aa28392d-realestate_small.webp";